import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { ReleaseEnvironment } from '../../../../../../types/releaseEnvironment';

type Props = {
  mode: '登録' | '更新';
  values: ReleaseEnvironment;
  handleClose: () => void;
  componentList: { id: number | undefined; name: string }[];
};

export const EnvironmentRegistrationResultModalView: FC<Props> = ({
  mode,
  values,
  handleClose,
  componentList,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">環境の{mode}</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>環境名</FormLabel>
          <Input
            type="text"
            value={values.name}
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
        <FormControl>
          {values.components?.map((component, index) => (
            <Stack key={index.toString()}>
              <FormLabel>コンポーネント: {index + 1}</FormLabel>
              <Stack pl="5">
                <FormLabel>コンポーネント名</FormLabel>
                {componentList.map(
                  (list) =>
                    Number(component.id) === list.id && (
                      <Stack key={list.id}>
                        <Input
                          type="text"
                          value={list.name}
                          variant="flushed"
                          isReadOnly
                        />
                      </Stack>
                    ),
                )}
                <FormLabel>バージョン</FormLabel>
                <Input
                  type="text"
                  value={component.version}
                  variant="flushed"
                  isReadOnly
                />
              </Stack>
            </Stack>
          ))}
        </FormControl>
      </Stack>
      <Text align="center" fontWeight="bold" mt="60px">
        {mode}が完了しました
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        variant="outline"
        onClick={handleClose}
      >
        閉じる
      </Button>
    </ModalFooter>
  </ModalContent>
);
